import React, { useEffect } from "react";
import { getAllSettings } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { FormattedMessage, useIntl } from "react-intl";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import SiteInfo from "./SiteInfo";

const Settings = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();

  const { error } = useSelector((state) => state.settings);

  useEffect(() => {
    dispatch(getAllSettings());
  }, [dispatch]);

  useEffect(() => {
    if (error) {
      toast.error(<FormattedMessage id={"sendingErrorMessage"} />, {
        position: "bottom-left",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }, [error]);

  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  return (
    <div className="acc-form settings_tabs">
      {/* <Tabs
        defaultActiveKey="mainSettings"
        id="home_page_tabs"
        className="home_page_tabs__"
      >
        <Tab
          eventKey="mainSettings"
          title={formatMessage({ id: "mainSettings" })}
        > */}
      <SiteInfo />
      {/* </Tab> */}
      {/* <Tab
          eventKey="socialTypesSettings"
          title={formatMessage({ id: "socialTypesSettings" })}
        >
          <SocialTypesSettings />
        </Tab>
        <Tab
          eventKey="socialSettings"
          title={formatMessage({ id: "socialSettings" })}
        >
          <SocialTypesSettings />
        </Tab> */}
      {/* </Tabs> */}
    </div>
  );
};

export default Settings;
